import React from 'react';

const Iowa = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Iowa Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Disclosure form with 19 questions required..</li>
        <li>Seller’s Disclosure of Property Condition: Required by law.</li>
        <li>Well Disclosure: Required if the property has a private well</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Iowa-Home-Buyers-and-Sellers-Fact-Sheet.pdf',
                '_blank'
              );
            }}
          >
            Radon Disclosure Fact Sheet{' '}
          </span>{' '}
          – Though not required, it is recommended to disclose information
          regarding radon.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Iowa-Seller-Property-Condition-Disclosure.pdf',
                '_blank'
              );
            }}
          >
            Seller Property Condition Disclosure{' '}
          </span>{' '}
          – The seller must complete this form, which covers structural and
          material damage, environmental issues, zoning information, and other
          relevant data.
        </li>
      </ol>
    </div>
  );
};

export default Iowa;
